import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { env } from 'utils/env'
import { getEnvs, getUrlConfig } from './functions'
import ChatLoggedIn from './webchat/ChatLoggedIn'
import ChatAnonymous from './webchat/ChatAnonymous'

const ChatContainer = ({ isLite = false }) => {
  const { i18n } = useTranslation()
  const {
    botAvatarImage,
    botInitials,
    displayInnerHeader,
    forceAutoscrollOnNewMessage,
    hideNewConversationButton,
    hideUploadButton,
    isAnonymous,
    soundUrl,
    refreshTokenTimeout
  } = useMemo(() => getEnvs(env, isLite), [isLite])
  const urlConfig = useMemo(() => getUrlConfig(env, isAnonymous), [isAnonymous])
  const sessionId = useMemo(() => new URLSearchParams(window.location.search).get('sessionId'), [])

  const chatbotName = useMemo(() => {
    const names = i18n.languages.reduce(
      (acc, lang) => ({
        ...acc,
        [lang]: env.REACT_APP_CHATBOT_NAME
      }),
      { default: env.REACT_APP_CHATBOT_NAME }
    )
    return names
  }, [i18n.languages])

  const headerFollowupText = useMemo(() => {
    const texts = i18n.languages.reduce(
      (acc, lang) => ({
        ...acc,
        [lang]: env[`REACT_APP_CHATBOT_HEADER_SUBTEXT_${lang?.toUpperCase()}`] ?? env.REACT_APP_CHATBOT_HEADER_SUBTEXT
      }),
      { default: env.REACT_APP_CHATBOT_HEADER_SUBTEXT }
    )
    return texts
  }, [i18n.languages])

  const Comp = useMemo(() => {
    return isAnonymous ? ChatAnonymous : ChatLoggedIn
  }, [isAnonymous])

  return (
    <Comp
      isAnonymous={isAnonymous}
      urlConfig={urlConfig}
      displayInnerHeader={displayInnerHeader}
      chatbotName={chatbotName}
      headerFollowupText={headerFollowupText}
      hideUploadButton={hideUploadButton}
      hideNewConversationButton={hideNewConversationButton}
      botAvatar={{
        image: botAvatarImage,
        initials: botInitials
      }}
      soundUrl={soundUrl}
      forceAutoscrollOnNewMessage={forceAutoscrollOnNewMessage}
      isDevelopment={false}
      headerChatVersion={'0.0.0'}
      emojiSet={false}
      sessionId={sessionId}
      refreshTokenTimeout={refreshTokenTimeout}
    />
  )
}

ChatContainer.propTypes = {
  isLite: PropTypes.bool
}

export default ChatContainer
